import styled from '@emotion/styled';

export const Dropzone = styled.div`
    height: 180px;
    white-space: pre-line;
    color: darkgray;
    text-align: center;
    border: dotted lightgrey 2.5px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const Dropped = styled.div`
    justify-content: center;
    text-align: center;
    overflow-wrap: anywhere;
`;
